var js = {exports: {}};

export { js as __module };
